// Paid research opportunities per condition. URLs link to share.realpatients.com.
export const OPPORTUNITIES = {
  Lupus: [
    {
      id: 'lupus-opp-1', type: 'Interview', title: '60-Minute Phone Interview',
      pay: '$150', duration: '1 hour', referralPay: '$50',
      description: 'Share your experience managing lupus flares with a research team developing new patient support tools.',
      details: ['1-hour phone interview with a researcher', 'Flexible scheduling — evenings and weekends available'],
      purpose: 'To understand how lupus patients manage flares and seek information during active symptoms.',
      requirements: ['Diagnosed with lupus (SLE)', 'US Resident', '18+', 'Experienced at least one flare in the past 12 months'],
      url: 'https://share.realpatients.com'
    },
    {
      id: 'lupus-opp-2', type: 'Survey', title: 'Treatment Satisfaction Survey',
      pay: '$75', duration: '20 min', referralPay: '$25',
      description: 'Help researchers understand what matters most to lupus patients when evaluating treatments.',
      details: ['20-minute online survey', 'Complete on your own time'],
      purpose: 'To map patient priorities when evaluating treatment options for lupus.',
      requirements: ['Diagnosed with lupus (SLE)', 'US Resident', '18+', 'Currently taking at least one lupus medication'],
      url: 'https://share.realpatients.com'
    },
    {
      id: 'lupus-opp-3', type: 'Focus Group', title: 'Virtual Focus Group',
      pay: '$300', duration: '90 min', referralPay: '$50',
      description: 'Join 5-7 other lupus patients to discuss unmet needs and gaps in current care.',
      details: ['90-minute live virtual session via Zoom', '5-7 participants per group', 'Moderated discussion — no prep required'],
      purpose: 'To receive patient feedback on unmet needs in lupus care and identify gaps in current treatment.',
      requirements: ['Diagnosed with lupus (SLE)', 'US Resident', '18+'],
      url: 'https://share.realpatients.com'
    },
  ],
  Narcolepsy: [
    {
      id: 'narc-opp-1', type: 'Interview', title: 'Video Interview Study',
      pay: '$200', duration: '75 min', referralPay: '$50',
      description: 'Talk with researchers about your daily experience with narcolepsy and how it affects your routine.',
      details: ['75-minute video call via Zoom', 'Flexible scheduling available'],
      purpose: 'To understand the daily lived experience of narcolepsy and its impact on work, relationships, and quality of life.',
      requirements: ['Diagnosed with narcolepsy (Type 1 or Type 2)', 'US Resident', '18+'],
      url: 'https://share.realpatients.com'
    },
    {
      id: 'narc-opp-2', type: 'Survey', title: 'Medication Experience Survey',
      pay: '$75', duration: '25 min', referralPay: '$25',
      description: 'Rate your experience with current and past narcolepsy medications.',
      details: ['25-minute online survey', 'Complete on your own time'],
      purpose: 'To gather real-world patient feedback on narcolepsy medication efficacy and side effects.',
      requirements: ['Diagnosed with narcolepsy', 'US Resident', '18+', 'Currently or previously treated with medication'],
      url: 'https://share.realpatients.com'
    },
    {
      id: 'narc-opp-3', type: 'Advisory Board', title: 'Patient Advisory Board',
      pay: '$500', duration: '2 hours', referralPay: '$75',
      description: 'Advise a pharmaceutical company on their narcolepsy treatment development program.',
      details: ['2-hour virtual advisory board session', '6-8 participants', 'Materials provided in advance'],
      purpose: 'To incorporate patient perspectives into clinical trial design and treatment development.',
      requirements: ['Diagnosed with narcolepsy', 'US Resident', '18+', 'Willing to review materials before the session'],
      url: 'https://share.realpatients.com'
    },
  ],
  'Polycythemia Vera': [
    {
      id: 'pv-opp-1', type: 'Interview', title: 'Phone Interview',
      pay: '$175', duration: '60 min', referralPay: '$50',
      description: 'Discuss your PV diagnosis journey and how you manage symptoms day to day.',
      details: ['60-minute phone interview', 'Flexible scheduling — evenings and weekends available'],
      purpose: 'To understand the PV patient journey from diagnosis through ongoing management.',
      requirements: ['Diagnosed with polycythemia vera', 'US Resident', '18+'],
      url: 'https://share.realpatients.com'
    },
    {
      id: 'pv-opp-2', type: 'Survey', title: 'Quality of Life Survey',
      pay: '$50', duration: '15 min', referralPay: '$25',
      description: 'Help map how PV impacts daily activities and emotional wellbeing.',
      details: ['15-minute online survey', 'Complete on your own time'],
      purpose: 'To quantify the quality-of-life impact of PV on daily activities.',
      requirements: ['Diagnosed with polycythemia vera', 'US Resident', '18+'],
      url: 'https://share.realpatients.com'
    },
    {
      id: 'pv-opp-3', type: 'Focus Group', title: 'Virtual Focus Group',
      pay: '$350', duration: '90 min', referralPay: '$50',
      description: 'Share perspectives on PV treatment burden and what better care could look like.',
      details: ['90-minute live virtual session via Zoom', '5-7 participants per group'],
      purpose: 'To explore treatment burden and identify what better PV care looks like from the patient perspective.',
      requirements: ['Diagnosed with polycythemia vera', 'US Resident', '18+', 'Currently receiving treatment'],
      url: 'https://share.realpatients.com'
    },
  ],
  _default: [
    {
      id: 'gen-opp-1', type: 'Interview', title: 'Patient Experience Interview',
      pay: '$150', duration: '60 min', referralPay: '$50',
      description: 'Share your healthcare journey with researchers working to improve patient outcomes.',
      details: ['60-minute phone or video interview', 'Flexible scheduling available'],
      purpose: 'To understand the patient experience and identify opportunities to improve care.',
      requirements: ['Diagnosed with a chronic condition', 'US Resident', '18+'],
      url: 'https://share.realpatients.com'
    },
    {
      id: 'gen-opp-2', type: 'Survey', title: 'Healthcare Experience Survey',
      pay: '$50', duration: '15 min', referralPay: '$25',
      description: 'Help researchers understand what patients value most in their care experience.',
      details: ['15-minute online survey', 'Complete on your own time'],
      purpose: 'To understand what patients value most when interacting with the healthcare system.',
      requirements: ['Diagnosed with a chronic condition', 'US Resident', '18+'],
      url: 'https://share.realpatients.com'
    },
  ]
};
